import { queryClient } from '../App';
import { setWithdrawSession, useWithdrawStore } from '../storage/withdrawState';
import { DEFAULT_DEBOUNCE_MS } from '../hooks/useDebouncedValue';

/**
 * Bridges the `REFRESH_WITHDRAW_STATUS_SCREEN` socket event to the status
 * screen's react-query cache.
 *
 * Android does the same in `WithdrawStatusViewModel.handleUiEvents`: cancel any
 * pending refresh, wait 500ms, then refetch the status for the session carried
 * on the event. The status screen is push-driven, never polled.
 */
let refreshTimer: ReturnType<typeof setTimeout> | undefined;

export function refreshWithdrawStatus(payload?: { sessionId?: string }) {
  const sessionId = payload?.sessionId;

  // Ignore events for a session that is not the one on screen.
  const currentSessionId = useWithdrawStore.getState().sessionId;
  if (sessionId && currentSessionId && sessionId !== currentSessionId) return;

  if (sessionId && !currentSessionId) setWithdrawSession(sessionId);

  if (refreshTimer) clearTimeout(refreshTimer);
  refreshTimer = setTimeout(() => {
    queryClient?.invalidateQueries(['payoutStatus']);
  }, DEFAULT_DEBOUNCE_MS);
}

export function cancelWithdrawStatusRefresh() {
  if (refreshTimer) clearTimeout(refreshTimer);
  refreshTimer = undefined;
}
